/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable  @angular-eslint/component-selector */
import { Observable } from 'rxjs';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
declare const $: any;
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceInRequiredValidator } from '../../../shared/constants';

@Component({
	selector: 'vessel-form',
	templateUrl: './vessel-form.component.html',
	styleUrl: './vessel-form.component.css'
})
export class VesselFormComponent implements OnInit {
	moduleForm!: FormGroup;
	showLoader = false;
	pageLoading = false;
	@Input() uId: any = null;
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	customError: any = {};
	UserModuleAccess: any = "Full";
	formSubmitted = false;
	companyList: any = [];
	filteredVesselTypes!: Observable<any[]>;
	vesselTypeList: any = [];

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute) {
		this.moduleForm = this.formBuilder.group({
			vessel_name: [null, [Validators.required, noWhitespaceInRequiredValidator]],
			co_id_id: [null, [Validators.required, noWhitespaceInRequiredValidator]],
			TypeOfVessel: [null, [Validators.required, noWhitespaceInRequiredValidator]],
			ImoNo: [null],
			Route: [null],
			CallSign: [null],
		});
		/* this.filteredVesselTypes = this.f.TypeOfVessel.valueChanges.pipe(
			startWith(''),
			map(value => this._filter(value || '')),
		); */
		/* this.apiService.getUserAccess().subscribe((data:any) => {
		try {
		let accessObj:any = JSON.parse(data.res[0].UserModuleAccess);
		this.UserModuleAccess = accessObj["Vessels"];
		} catch (error) {}
		},(error:any) => {
		this.UserModuleAccess = "NoAccess";
		}); */
	}

	get f() { return this.moduleForm.controls; }

	ngOnInit(): void {
		this.getCompanyList();
		/* this.getVesselTypes(); */
		if (this.uId) {
			this.getDetails();
		}
	}

	private _filter(value: string): string[] {
		const filterValue = value.toLowerCase();
		return this.vesselTypeList.filter(option => option.toLowerCase().includes(filterValue));
	}

	getCompanyList() {
		this.apiService.getCompany({}).subscribe({
			next: (data: any) => {
				this.companyList = data.data;
			}, error: () => {
				this.companyList = [];
			}
		});
	}

	/* getVesselTypes() {
		this.apiService.getVesselTypeDetails({}).subscribe((data: any) => {
			this.vesselTypeList = data.map((vt: any) => vt.name);
		}, (error) => {
			this.vesselTypeList = [];
		});
	} */

	clearForm() {
		this.moduleForm.reset();
		this.cleared.emit();
	}

	getDetails() {
		this.pageLoading = true;
		this.apiService.getVessel({ id: this.uId }).subscribe({
			next: (data: any) => {
				const obj = data.data;
				this.moduleForm.setValue({
					vessel_name: obj.vessel_name,
					co_id_id: obj.co_id_id,
					TypeOfVessel: obj.TypeOfVessel,
					ImoNo: obj.ImoNo,
					Route: obj.Route,
					CallSign: obj.CallSign,
				});
				this.moduleForm.disable();
				this.pageLoading = false;
			}, error: (error) => {
				this.pageLoading = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) { }
			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required fields", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		const data: any = {
			vessel_name: this.f.vessel_name.value,
			co_id_id: this.f.co_id_id.value,
			TypeOfVessel: this.f.TypeOfVessel.value,
			ImoNo: this.f.ImoNo.value,
			Route: this.f.Route.value,
			CallSign: this.f.CallSign.value,
		};
		if (this.uId) {
			data.id = this.uId;
		}
		this.showLoader = true;
		this.apiService.createUpdateVessel(data).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.created.emit(data);
				this.clearForm();
			}, error: (error) => {
				this.showLoader = false;
				if (error.status == 401) { return }
				let errorMsg = "Something went wrong.";
				if (error.status == 400) {
					errorMsg = error.error;
					if (typeof errorMsg == 'object') {
						for (const [key, value] of Object.entries(errorMsg)) {
							const val: any = value;
							if (val[0] == "This field must be unique.") {
								val[0] = "Already exists";
							}
							if (this.moduleForm.controls[key]) {
								this.moduleForm.controls[key].setErrors({ incorrect: true });
								this.customError[key] = val[0];
								const selector = "#" + key;
								try {
									$('html, body').animate({
										scrollTop: $(selector).offset().top - 60 + 'px'
									}, 'fast');
								} catch (error) { }
								$(selector).focus();
							} else {
								this.toastr.error(key + ":" + val[0], 'Error', {
									timeOut: 3000,
									tapToDismiss: true,
									closeButton: true
								});
							}
						}
						return;
					} else {
						errorMsg = "Vessel already exists";
					}
				}
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}
}
